/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { MENU_ITEMS_BY_PAGE } from 'constants/header'
import { withLocalization } from 'hocs/localization'
import { getUserRole } from 'redux-app/selectors/auth'
import HeaderMenu from './HeaderMenu'

const getItems = createSelector(
  (state, { page }) => page,
  getUserRole,
  (page, role) => MENU_ITEMS_BY_PAGE[page].filter(({ visibleFor }) => {
    if (!visibleFor) {
      return true
    }
    return visibleFor.includes(role)
  }),
)

export default compose<any, any>(
  connect(
    (state, props) => ({
      items: getItems(state, props),
    }),
    null,
  ),
  withLocalization('header.pagesMenu'),
)(HeaderMenu)
